import { Box, Button, styled, Typography } from '@mui/material';
import { IconDocument } from 'assets/img';

export const FlexRowBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
}));

export const FlexRowBoxCenter = styled(FlexRowBox)(() => ({
  alignItems: 'center',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const FlexColumnBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const ModalWrapperBox = styled(FlexColumnBox)(({ theme }) => ({
  padding: theme.spacing(8),
  height: '100%',
}));

export const HeaderWrapper = styled(FlexRowBoxCenter)<{ cursor?: string }>(({ theme, cursor }) => ({
  justifyContent: 'flex-start',
  marginBottom: theme.spacing(3),
  overflow: 'hidden',
  ...(cursor && { cursor }),
}));

export const ImageWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: theme.spacing(2),
}));

export const InfoWrap = styled(FlexRowBoxCenter)(() => ({
  marginLeft: 'auto',
  cursor: 'default',
}));

export const CredentialText = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: 500,
  marginLeft: theme.spacing(1),
  opacity: '0.6',
}));

export const StyledIcon = styled('svg')(() => ({
  '& path': {
    stroke: 'rgba(0, 0, 0, 0.4)',
  },
}));

export const FlexColumnBoxWrap = styled(FlexColumnBox)(() => ({
  overflow: 'auto',
}));

export const CertificateInfo = styled(FlexRowBox)(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

export const CertificateWrap = styled(FlexColumnBox)(({ theme }) => ({
  alignItems: 'flex-start',
  marginRight: theme.spacing(8),
}));

export const CertificateInfoWrapper = styled(FlexColumnBox)(() => ({
  width: '100%',
  justifyContent: 'space-between',
}));

export const ButtonWrapCertificate = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(1),
}));

export const OpenCertificateButton = styled(Button)(({ theme }) => ({
  '&.MuiButton-root': {
    width: '100%',
    border: '1px solid rgba(0,0,0,0.3)',
    borderRadius: theme.spacing(7),
    padding: '8px 10px',
    fontWeight: 700,
    fontSize: '12px',
    color: 'rgba(0,0,0,0.6)',
  },
}));

export const NameBox = styled(FlexRowBox)(() => ({
  height: '48px',
}));

export const DateBox = styled(FlexRowBox)(() => ({
  width: '40%',
}));

export const CertificateName = styled(Typography)(() => ({
  fontSize: '18px',
  fontWeight: 700,
  lineHeight: '24px',
}));

export const ButtonBigWrap = styled(FlexRowBox)(({ theme }) => ({
  marginTop: theme.spacing(10),
  marginBottom: theme.spacing(2),
  justifyContent: 'center',
}));

export const ButtonWrap = styled(FlexRowBox)(({ theme }) => ({
  justifyContent: 'space-around',
  gap: theme.spacing(4),
}));

export const StyledIconDocument = styled(IconDocument)<{ hasFile: boolean }>(({ hasFile }) => ({
  cursor: hasFile ? 'pointer' : 'not-allowed',
  opacity: hasFile ? 1 : 0.5,
}));
